import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=5e5a8b80&scoped=true&"
import script from "./NewDashboard.vue?vue&type=script&lang=js&"
export * from "./NewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=5e5a8b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a8b80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
